export const PRODUCT_PRESET_SORTER = [
  {
    field: 'number',
    sortValue: 'product.number',
    descend: '-product.number',
    ascend: 'product.number',
  },
  {
    field: 'name',
    sortValue: 'product.name',
    descend: '-product.name',
    ascend: 'product.name',
  },
  {
    field: 'supplier',
    sortValue: 'supplier.name',
    descend: '-supplier.name',
    ascend: 'supplier.name',
  },
]

export type PRODUCT_PAYLOAD_TYPE = {
  search?: string | null
  number?: string | string[] | null
  name?: string | string[] | null
  suppliers?: string | string[] | null
  [key: string]: any
}

export const DEFAULT_PRODUCT_FILTER: PRODUCT_PAYLOAD_TYPE = {
  search: null,
  number: null,
  name: null,
  suppliers: null,
}

export const PRODUCT_ADVANCE_FILTER_LISTING: (keyof PRODUCT_PAYLOAD_TYPE)[] = [
  'search',
  'number',
  'name',
  'suppliers',
]
